import styled from "styled-components";
import { Card, Tooltip, Upload } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";

export const RemappingPage = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
  width: 100%;
`;

export const RemappingHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-sm);
  flex-wrap: wrap;

  @media (max-width: 1023px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const HeaderTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const BatchButton = styled.div`
  width: 250px;

  .ant-btn {
    width: 100%;
    justify-content: flex-start;
  }

  @media (max-width: 1023px) {
    width: 100%;
  }
`;

export const Workflow = styled.section`
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  background: #f7f9fc;
  border: 1px solid #e8ecf0;
  border-radius: 8px;
  padding: var(--spacing-sm);
  box-shadow: none;
`;

export const WorkflowRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: var(--spacing-sm);
  align-items: stretch;
  max-width: 100%;

  @media (max-width: 1023px) {
    flex-direction: column;
    width: 100%;
  }
`;

export const UploadArea = styled(Upload.Dragger)`
  &.ant-upload-wrapper {
    display: block;
    flex: 0 0 700px;
    width: 700px;
    height: auto;
  }

  .ant-upload-list {
    display: none;
  }

  .ant-upload-drag {
    min-height: unset;
    padding: var(--spacing-xs) var(--spacing-sm);
    border-radius: 8px;
    background: var(--color-background);
    box-shadow: none !important;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .ant-upload-drag:not(.ant-upload-disabled):hover {
    box-shadow: none !important;
  }

  .ant-upload-btn {
    padding: 0;
  }

  .ant-upload-drag-icon {
    margin-bottom: 4px;
    line-height: 1;
  }

  .ant-upload-drag-icon .anticon {
    font-size: 24px;
  }

  .ant-upload-text {
    margin: 0;
    font-size: 13px;
    line-height: 1.4;
  }

  @media (max-width: 1023px) {
    &.ant-upload-wrapper {
      flex: 1 1 auto;
      width: 100%;
      height: auto;
    }

    .ant-upload-drag {
      height: auto;
    }
  }
`;

export const Sidebar = styled.aside`
  display: flex;
  flex-direction: column;
  flex: 0 0 280px;
  width: 280px;
  gap: var(--spacing-xs);

  @media (max-width: 1023px) {
    flex: 1 1 auto;
    width: 100%;
  }
`;

export const StatusPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: var(--spacing-xs) var(--spacing-sm);
  background: var(--color-background);
  border-radius: 8px;
  border: 1px solid #e8ecf0;
  box-shadow: none;
  flex: 1;
  width: 100%;
  min-width: 0;
  overflow: hidden;
`;

export const StatusRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--spacing-xs);
  min-width: 0;
`;

export const StatusFile = styled.div`
  flex: 1;
  min-width: 0;
  text-align: right;
  overflow: hidden;
`;

export const SummaryCard = styled(Card)`
  &.ant-card {
    box-shadow: none !important;
    background: #f7f9fc;
    border: 1px solid #e8ecf0;
    border-radius: 8px;
  }

  .ant-card-body {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: var(--spacing-xs);
    padding: var(--spacing-xs) var(--spacing-sm);
  }
`;

export const HistorySection = styled.section`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
`;

export const HistoryHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StatusBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--spacing-xs);
  align-items: stretch;
`;

export const CustomTooltip = styled(Tooltip)`
  background-color: #f5f5f5;
  color: #262626;
`;

export const CustomQuestionIcon = styled(QuestionCircleOutlined)`
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #8c8c8c;
  cursor: pointer;
  background: none;

  &:hover {
    color: #595959;
  }
`;

export const StatusFileName = styled.span`
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: none;
`;

export const NameCell = styled.div`
  position: relative;
  width: 100%;
  text-align: center;
  /* btn width (~32px) + gap */
  padding-left: calc(32px + var(--spacing-xs));
`;

export const NameCellLabel = styled.span`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const NameCellActions = styled.span`
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
`;

export const StatusSpace = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const StatusTagWrap = styled.span`
  position: relative;
  display: inline-flex;
`;

export const StatusErrorIcon = styled(CustomQuestionIcon)`
  position: absolute;
  left: 100%;
  margin-left: var(--spacing-xs);
  top: 50%;
  transform: translateY(-50%);
`;
